import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { HardDrive, ArrowUpCircle } from "lucide-react";

const fmtGb = (mb) => (mb >= 1024 ? `${(mb / 1024).toFixed(mb % 1024 ? 1 : 0)} GB` : `${mb} MB`);

const StorageBar = ({ compact = false }) => {
  const [s, setS] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/storage").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return null;
  const pct = Math.min(100, s.limit_mb ? (s.used_mb / s.limit_mb) * 100 : 0);
  const near = pct >= 85;

  if (compact) {
    return (
      <div className="flex items-center gap-3 mb-8" data-testid="storage-bar">
        <HardDrive className="w-4 h-4 text-[#81B29A] shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-3 mb-1">
            <p className="text-xs text-muted-foreground truncate">
              Piano {s.plan_name} · {fmtGb(s.used_mb)} di {fmtGb(s.limit_mb)}
            </p>
            <button onClick={() => navigate("/piani")} className="text-xs text-primary hover:underline shrink-0" data-testid="storage-upgrade-btn">
              {s.plan_name === "Free" ? "Aumenta spazio" : "Cambia piano"}
            </button>
          </div>
          <div className="h-1.5 rounded-full bg-[#F0E9DC] overflow-hidden">
            <div className={`h-full rounded-full transition-all ${near ? "bg-primary" : "bg-[#81B29A]"}`} style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-border p-6 mb-8" data-testid="storage-bar">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#EAF2ED] flex items-center justify-center">
            <HardDrive className="w-5 h-5 text-[#81B29A]" />
          </div>
          <div>
            <p className="font-medium">Spazio · Piano {s.plan_name}</p>
            <p className="text-sm text-muted-foreground">{fmtGb(s.used_mb)} di {fmtGb(s.limit_mb)} utilizzati</p>
          </div>
        </div>
        <Button onClick={() => navigate("/piani")} variant="outline" className="rounded-full border-border" data-testid="storage-upgrade-btn">
          <ArrowUpCircle className="w-4 h-4 mr-2" /> {s.plan_name === "Free" ? "Aumenta spazio" : "Cambia piano"}
        </Button>
      </div>
      <div className="h-2.5 rounded-full bg-[#F0E9DC] overflow-hidden">
        <div className={`h-full rounded-full transition-all ${near ? "bg-primary" : "bg-[#81B29A]"}`} style={{ width: `${pct}%` }} />
      </div>
      {near && <p className="text-xs text-primary mt-2">Spazio quasi esaurito — valuta un upgrade per continuare a custodire ricordi.</p>}
    </div>
  );
};

export default StorageBar;
